// interface
import { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { UserTypes, UserTypes as UserTypes2s } from "../../../api/auth";
import { createSelector } from "reselect";
import { ChatContact2, fetchChatContactsRequest } from "../../../redux/chats/slice";
import { FixedSizeList as List } from 'react-window';

// component
import ChatUser from "./ChatUser";
import { useRedux } from "hooks";
import { Utils } from "helpers/utils";
import ChatUser2 from "./ChatUser2";
import { Spinner } from "react-bootstrap";
import LoadingIconWithText from "components/LoadingIconWithText";
import { TABS } from "../../../constants";
interface ChatRoomListProps {
  users: Array<UserTypes>;
  selectedChat: string | number;
  onSelectChat: (id: number | string) => void;
  onReloadChatList: () => void;
  groupType: UserTypes;
}

// 20250902 move to inside component
// const selectorData = createSelector(
//   (state: any) => state.Login,
//   (state: any) => state.Profile2,
//   (layout: any) => layout.Layout,
//   (chat: any) => chat.Chats,
//   (chat2: any) => chat2.ChatContacts2,
//   (login, profile2, layout, chat, chat2) => ({
//     isUserLogin: login.isUserLogin,
//     error: login.error,
//     loginLoading: login.loading,
//     isUserLogout: login.isUserLogout,

//     logonUserName: profile2.userName,
//     profile2: profile2,
//     activeGroupId: profile2.activeGroupId,

//     chatConnectError: layout.chatConnectError,
//     activeTab: layout.activeTab, // 20250902
//     getChatRoomListsLoading: chat.getChatRoomListsLoading,
//     selectedChat: chat.selectedChat,

//     chatContacts: chat2.chatContacts,
//     loading: chat2.loading,
//     errorMsg: chat2.errorMsg,
//     currentPage: chat2.currentPage,
//     nextPage: chat2.nextPage,
//     hasMore: chat2.hasMore,
//     filter: chat2.filter
//   })
// );


const ChatRoomList = ({ users, selectedChat, onSelectChat, onReloadChatList, groupType }: ChatRoomListProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const selectorData = createSelector(
    (state: any) => state.Login,
    (state: any) => state.Profile2,
    (layout: any) => layout.Layout,
    (chat: any) => chat.Chats,
    (chat2: any) => chat2.ChatContacts2,
    (login, profile2, layout, chat, chat2) => ({
      isUserLogin: login.isUserLogin,
      error: login.error,
      loginLoading: login.loading,
      isUserLogout: login.isUserLogout,

      logonUserName: profile2.userName,
      profile2: profile2,
      activeGroupId: profile2.activeGroupId,

      chatConnectError: layout.chatConnectError,
      activeTab: layout.activeTab, // 20250902
      getChatRoomListsLoading: chat.getChatRoomListsLoading,
      selectedChat: chat.selectedChat,

      chatContacts: groupType == UserTypes.Group ? chat2.chatContacts : chat2.chatContactsSup,
      loading: groupType == UserTypes.Group ? chat2.loading : chat2.loadingSup,
      errorMsg: groupType == UserTypes.Group ? chat2.errorMsg : chat2.errorMsgSup,
      currentPage: groupType == UserTypes.Group ? chat2.currentPage : chat2.currentPageSup,
      nextPage: groupType == UserTypes.Group ? chat2.nextPage : chat2.nextPageSup,
      hasMore: groupType == UserTypes.Group ? chat2.hasMore : chat2.hasMoreSup,
      filter: groupType == UserTypes.Group ? chat2.filter : chat2.filterSup
    })
  );
  const { profile2, activeGroupId, chatConnectError, getChatRoomListsLoading
    , chatContacts, loading, errorMsg, currentPage, nextPage, hasMore, filter, activeTab
  } = useAppSelector(selectorData);
  // console.log('chat2:',chat2);

  //  console.log('users: ', users);
  // console.log('profile2 = ', profile2);

  // const [title, setTitle] = useState('รายชื่อห้อง');
  const isCustomer = (profile2 && profile2.userType == UserTypes2s.Customer);
  const isSupplier = (profile2 && profile2.userType == UserTypes2s.Supplier);
  const is2s = !isCustomer;
  //const title = isCustomer ? ("คุยกับ " + process.env.REACT_APP_COMPANY_ABBR) : "รายชื่อลูกค้า";
  const title = (() => {
    if (isCustomer || isSupplier) return "คุยกับ " + process.env.REACT_APP_COMPANY_ABBR;
    if (groupType == UserTypes.Group) return "รายชื่อลูกค้า";
    if (groupType == UserTypes.GroupSupplier) return "Supplier";
    return "ห้องแชท";
  })();

  const onReloadChatRoom = async () => {
    onReloadChatList();
  }


  useEffect(() => {
    // console.log('ChatRoomList.tsx -> useEffect[dispatch]');
    // console.log('dispatch fetchChatContactsRequest 1 gruop type = ' + groupType);
    dispatch(fetchChatContactsRequest({ page: 1, filter: filter, isFetchNext: false, currentSelectedChatId: selectedChat, groupType: groupType }));
    // console.log('dispatch fetchChatContactsRequest 2');
  }, [dispatch]);

  const handleScroll = () => {
    // console.log('handleScore', divRef.current);
    if (!divRef.current) return;
    if (!hasMore) return;
    // console.log('handleScore');

    const { scrollTop, scrollHeight, clientHeight } = divRef.current;

    // Check if user has scrolled close to the bottom
    if (scrollHeight - scrollTop <= clientHeight + 150 && !loading) {
      dispatch(fetchChatContactsRequest({ page: nextPage, filter: filter, isFetchNext: true, currentSelectedChatId: selectedChat, groupType: groupType }));
    }
  };

  // console.log('chatContacts:', chatContacts);
  const divRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const div = divRef.current;

  //   if (!div) return;

  //   let timeout: NodeJS.Timeout;

  //   const handleScroll = () => {
  //     div.classList.add("scrolling");
  //     clearTimeout(timeout);
  //     timeout = setTimeout(() => div.classList.remove("scrolling"), 300); // Hide after 500ms
  //   };

  //   div.addEventListener("scroll", handleScroll);

  //   return () => {
  //     div.removeEventListener("scroll", handleScroll);
  //     clearTimeout(timeout);
  //   };
  // }, []);



  return (
    <>
      {chatConnectError && (
        <h5 className="mb-3 px-4 mt-4 font-size-11 text-muted text-uppercase room-group-title non-login-chat-alert">
          <div className="mb-3 alert alert-danger fade show global-error text-center" role="alert">
            <span dangerouslySetInnerHTML={{ __html: chatConnectError }} />
            {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> */}
            {/* {chatConnectError == Utils.MSG_CHAT_DISCONNECT && (<a href="#" onClick={(e) => { e.preventDefault(); window.location.reload(); }}> รีโหลด</a>)} */}
          </div>
        </h5>
      )}
      <h5 className="mb-3 px-4 mt-4 font-size-11 text-muted text-uppercase room-group-title">
        {title}&nbsp;
        {loading && (
          <div className="spinner-border spinner-border-sm text-secondary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>)}
        {!loading && /*!isCustomer &&*/ (
          <i className="mdi mdi-reload text-secondary hand" style={{ fontSize: '1rem' }} onClick={onReloadChatRoom}></i>
        )}

        {/* {(
          <a href="#" onClick={onReloadChatRoom}>
            {!getChatRoomListsLoading && (<span className="mdi mdi-reload"></span>)}
            {getChatRoomListsLoading && (
              <div className="spinner-border spinner-border-sm text-secondary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>)}
          </a>
        )} */}

        {!loading && errorMsg && (<div className="fz-07 text-red">{errorMsg}</div>)}
      </h5>


      {/* <div ref={divRef} onScroll={handleScroll} className="chat-message-list chat-message-2s"> */}
      <div ref={divRef} onScroll={handleScroll} className={classnames("chat-message-list", { "chat-message-2s": !isCustomer })}>
        <ul className="list-unstyled chat-list chat-user-list ">
          {(chatContacts || []).map((eachContact: ChatContact2, key: number) => {
            // console.log(eachContact, activeGroupId);
            const visible = is2s || eachContact.userId == activeGroupId;
            return (
              <ChatUser2
                user={eachContact}
                key={key}
                selectedChat={selectedChat}
                onSelectChat={onSelectChat}
                is2s={is2s}
                visible={visible}
                keyIndex={key}
              />);
          })}
        </ul>

        {/* {loading && (<div className="px-4"><LoadingIconWithText/></div>)} */}
        {/* {!hasMore && (<p className="text-center">-- end of data --</p>)} */}

        {/* <ul className="list-unstyled chat-list chat-user-list">

          {(users || []).map((user: UserTypes, key: number) => {
            const visible = is2s || user.id == activeGroupId;
            return (
              <ChatUser
                user={user}
                key={key}
                selectedChat={selectedChat}
                onSelectChat={onSelectChat}
                is2s={is2s}
                visible={visible}
              />);
          })}
        </ul> */}
      </div>
    </>
  );
};

export default ChatRoomList;
